import { Link } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { useSeo } from "../lib/seo";

export default function NotFound() {
  useSeo({ title: "Page not found", noindex: true });
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-4" data-testid="not-found">
        <div className="text-center max-w-md">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-primary">404</p>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold text-slate-900 mt-2">Page not found</h1>
          <p className="text-slate-600 mt-3 text-sm sm:text-base">That link doesn't go anywhere. If you were finishing a checkout, no charge was made.</p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link to="/" className="rounded-full bg-slate-900 text-white px-5 py-2.5 text-sm font-semibold" data-testid="not-found-home">Go home</Link>
            <Link to="/dashboard" className="rounded-full border border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold text-slate-900" data-testid="not-found-dashboard">My dashboard</Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
